<template>
    <div class="page page-bg">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <img src="../../assets/images/logo-white.png" class="app-logo" />
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">华商云服APP</h2>
            </div>
            <div class="weui-msg__opr-area">
                <p class="weui-btn-area">
                    <launch-app />
                </p>
            </div>
        </div>
    </div>
</template>
  
<script>
import LaunchApp from "@/components/button/LaunchApp.vue";

export default {
    components: {
        LaunchApp,
    },
};
</script>

<style scoped>
.app-logo {
    width: 180px;
}
</style>